import React from 'react';
import {
  Modal as ReactModal,
  ModalProps as ReactModalProps,
} from 'react-bootstrap';
import styled from 'styled-components';
import { BsX } from 'react-icons/bs';

interface ModalProps extends ReactModalProps {
  show: boolean;
  close: () => void;
  title: string;
  noHeader?: boolean;
  subtitle?: string;
}

export const Modal = ({
  show,
  close,
  title,
  subtitle,
  children,
  noHeader,
  ...props
}: React.PropsWithChildren<ModalProps>) => (
  <ReactModal show={show} {...props}>
    <ReactModal.Body className="p-0">
      {!noHeader && (
        <ModalHeader className="px-4 py-3 d-flex justify-content-between">
          <div>
            <h4>{subtitle}</h4>
            <h1>{title}</h1>
          </div>
          <BsX size={38} onClick={close} />
        </ModalHeader>
      )}
      <LineContainer>
        <hr style={{ paddingRight: '20px' }} />
      </LineContainer>
      <div>{children}</div>
    </ReactModal.Body>
  </ReactModal>
);

const LineContainer = styled.div`
  display: none;
  padding: 0 20px;
  margin-top: -18px;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const ModalHeader = styled.div`
  background-color: ${(props) => props.theme.color.bg.secondary};

  h1 {
    color: ${(props) => props.theme.color.text.inverse};
    margin: 0;
  }
  h4 {
    color: ${(props) => props.theme.color.text.secondary};
    margin: 0;
  }
  svg {
    color: ${(props) => props.theme.color.text.inverse};
    cursor: pointer;
  }

  @media only screen and (max-width: 768px) {
    background-color: ${(props) => props.theme.color.bg.primary};
    border-radius: 3px;

    h1 {
      color: ${(props) => props.theme.color.text.primary};
    }

    svg {
      color: ${(props) => props.theme.color.text.disabled};
      cursor: pointer;
    }

    h4 {
      display: none;
    }
  }
`;
